import { useAuth } from '@libs/Auth/useAuth'
import LoadingBar from '@components/base/LoadingBar'
import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import OrganisationSettings from '@components/organisation/OrganisationSettings/OrganisationSettings'

export default function UserDetailsPage() {
  const { profile, isOrganizer, isAdmin, isLogged } = useAuth()
  const { push } = useRouter()
  const [isReady, setIsReady] = useState<boolean>(false)
  const [isAllowed, setIsAllowed] = useState<undefined | boolean>(undefined)

  // const perms = getPermission('USER::ACCESS_ORGANISATION::*')

  if (!isLogged) push('/login?previous=true')

  useEffect(() => {
    if (isOrganizer !== undefined && isAdmin !== undefined) {
      setIsReady(true)
      setIsAllowed(isOrganizer || !isAdmin)
    }
  }, [isOrganizer, isAdmin])

  useEffect(() => {
    if (profile && !isOrganizer) push(`/dashboard`)
  }, [isOrganizer, profile])

  useEffect(() => {
    if (isReady && isAllowed !== undefined && isAllowed == false) push('/')
  }, [isReady, isAllowed])

  if (!isReady || !profile || !isOrganizer) return <LoadingBar />

  return (
    <>
      <OrganisationSettings
        name={profile?.company || profile?.university || ''}
      />
    </>
  )
}
